<div class="message-popup-wrapper {{
    messagePopupData.code?.isForWarning ? 'warning' : ''
  }} {{
    messagePopupData.code?.isForAssociateUfoShipments
      ? 'associate-ufo-shipments-modal'
      : ''
  }} {{
    messagePopupData.code?.isArAdditionalChargesModal
      ? 'message-popup-wrapper--ar-additional-charges'
      : ''
  }}">
  <div class="message-popup-header" *ngIf="!messagePopupData.code?.isForWarning">
    <div class="ibc-body-text-large-bold">{{ messagePopupData.title }}</div>
    <div class="card-action-icons">
      <app-svg-icon [iconName]="'close'" class="cursor" [isStaticSvg]="true" [isFrom]="'Popup'"
        (staticIconClicked)="closePopup('close')"></app-svg-icon>
    </div>
  </div>
  <div class="message-popup-body" [class.associate-ufo-shipments-scrollable]="
      messagePopupData.code?.isForAssociateUfoShipments
    ">
    <div class="note-info" *ngIf="messagePopupData.code?.isForApChargesSelection">
      <app-information-note [message]="
          popupMessages.apMultiShipmentMessage(
            messagePopupData.code?.forIdentifierSelectionText
          )
        ">
      </app-information-note>
    </div>
    <div class="note-info" *ngIf="messagePopupData.code?.isForArChargesSelection">
      <app-information-note [message]="
          popupMessages.arMultiShipmentMessage(
            messagePopupData.code?.forIdentifierSelectionText
          )
        ">
      </app-information-note>
    </div>
    <div class="note-info" *ngIf="messagePopupData.code?.isForAssociateUfoShipments">
      <app-information-note [message]="popupMessages.associateUfoShipmentsBanner" [isFrom]="'associateUfoShipments'">
      </app-information-note>
    </div>
    <div cdkScrollable class="message-popup-content {{
        messagePopupData.code?.isForDownload
          ? 'pb-20'
          : !messagePopupData.code?.isMultiple &&
              messagePopupData.code?.isOptionalTextbox
            ? 'pb-0'
            : ''
      }} {{
        messagePopupData.code?.isForAssociateUfoShipments
          ? 'associate-ufo-shipments-popup'
          : ''
      }} {{
      messagePopupData.code?.isArAdditionalChargesModal &&
      !messagePopupData.code?.message
        ? 'message-popup-content--ar-additional-charges-only'
        : ''
    }}">
      <div class="ibc-body-text-medium confirmation-message message-text" *ngIf="
          messagePopupData.code?.message &&
          !messagePopupData.code?.isForWarning &&
          !messagePopupData.code?.isForMultipleBagSelection &&
          !messagePopupData.code?.isForMultiPieceGatewayConfirm
        ">
        {{ messagePopupData.code?.message }}
      </div>
      <div class="form-container invoice-date-prompt" *ngIf="messagePopupData.code?.isForInvoiceDatePrompt">
        <mat-form-field appearance="outline"
          class="mat-md custom-datepicker remove-focus remove-subscript-wrapper">
          <mat-label>Invoice Date</mat-label>
          <input matInput [matDatepicker]="invoiceDatePromptPicker" [(ngModel)]="invoiceDatePromptValue"
            [min]="invoiceDatePromptMinDate" [max]="invoiceDatePromptMaxDate"
            (click)="invoiceDatePromptPicker.open()" aria-label="Invoice Date" />
          <mat-datepicker-toggle matPrefix [for]="invoiceDatePromptPicker">
            <mat-icon matDatepickerToggleIcon>
              <app-svg-icon [iconName]="actionIcons.datePicker" [isStaticSvg]="true"></app-svg-icon>
            </mat-icon>
          </mat-datepicker-toggle>
          <mat-datepicker #invoiceDatePromptPicker></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="form-container publish-manifest-checkboxes" *ngIf="messagePopupData.code?.isForPublishTicketCheckbox">
        <mat-checkbox [(ngModel)]="isCheckboxChecked">
          <span class="ibc-body-text-medium">
            {{ messagePopupData.code?.checkboxData }}
          </span>
        </mat-checkbox>
        <mat-checkbox [(ngModel)]="isSendManifestViaEmail" (ngModelChange)="onSendManifestViaEmailToggle($event)">
          <span class="ibc-body-text-medium">{{
            popupMessages.sendManifestViaEmailMsg
            }}</span>
        </mat-checkbox>
      </div>
      <div class="ibc-body-text-medium confirmation-message" *ngIf="
          messagePopupData.code?.secondMessage &&
          !messagePopupData.code?.isForWarning &&
          !messagePopupData.code?.isApChargeDuplicateEntry
        ">
        {{ messagePopupData.code?.secondMessage }}
      </div>

      <ng-container *ngIf="messagePopupData.code?.isForMultiPieceGatewayConfirm">
        <div class="ibc-body-text-medium confirmation-text">
          {{ messagePopupData.code?.message }}
        </div>
        <mat-form-field appearance="outline" class="mat-md w-full input-wrapper-none">
          <input
            matInput
            type="number"
            min="1"
            step="1"
            [(ngModel)]="multiPiecePhysicalCountInput"
            [placeholder]="popupMessages.multiPiecePhysicalPieceCountPlaceholder" />
        </mat-form-field>
        <p
          *ngIf="getMultiPieceOverageErrorText()"
          class="ibc-body-text-medium multi-piece-overage-error">
          {{ getMultiPieceOverageErrorText() }}
        </p>
      </ng-container>

      <ng-container *ngIf="
          messagePopupData.code?.isForUserCreate ||
          messagePopupData.code?.isForCreateLinkedAccount ||
          messagePopupData.code?.isBagScanShipment ||
          (messagePopupData.code?.isApTpGpConfirmation &&
            messagePopupData.code?.confirmText)
        ">
        <div>
          <div class="ibc-body-text-medium confirmation-text" *ngIf="
              messagePopupData.code?.message !== '' &&
              !messagePopupData.code?.isForCreateLinkedAccount
            ">
            {{ getConfirmText() }}
          </div>
          <mat-form-field appearance="outline" class="mat-md w-full input-wrapper-none">
            <mat-label *ngIf="messagePopupData.code?.isForCreateLinkedAccount">Account</mat-label>
            <input matInput type="text" [(ngModel)]="confirmValue" (blur)="validateConfirmValue()"
              [placeholder]="renderPlaceholder()" />
          </mat-form-field>
        </div>
      </ng-container>

      <ng-container *ngIf="
          isSendManifestViaEmail &&
          messagePopupData.code?.isForPublishTicketCheckbox
        ">
        <div class="manifest-email-container">
          <mat-checkbox [(ngModel)]="manifestSendToMe" (change)="onManifestSendToMeCheckboxChange($event)">
            <span class="ibc-body-text-medium">{{
              popupMessages.sendItToMe
              }}</span>
          </mat-checkbox>

          <mat-form-field class="chip-autocomplete-field remove-subscript-wrapper" appearance="outline">
            <mat-chip-grid #manifestChipGrid aria-label="Email selection">
              <mat-chip-row *ngFor="let email of manifestSelectedEmails" (removed)="removeManifestEmail(email)"
                [aria-description]="'press enter to edit ' + email">
                {{ email }}
                <button matChipRemove [attr.aria-label]="'remove ' + email">
                  <mat-icon>cancel</mat-icon>
                </button>
              </mat-chip-row>
            </mat-chip-grid>
            <input placeholder="Enter valid email addresses" [formControl]="manifestEmailCtrl"
              [matChipInputFor]="manifestChipGrid" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              (keydown.enter)="$event.stopPropagation()" (matChipInputTokenEnd)="addManifestEmail($event)"
              (blur)="onManifestEmailBlur()" maxlength="185" />
          </mat-form-field>
          <div class="manifest-email-error" *ngIf="getManifestEmailDisplayError()">
            {{ getManifestEmailDisplayError() }}
          </div>

          <div class="manifest-email-row">
            <mat-form-field appearance="outline"
              class="mat-md custom-select mat-select-variants remove-subscript-wrapper manifest-email-half-field">
              <mat-label>Select Manifest format</mat-label>
              <mat-icon matPrefix class="dropdown-icon">
                {{ actionIcons.keyboardDownArrow }}
              </mat-icon>
              <mat-select [(ngModel)]="selectedManifestFormat" (ngModelChange)="onManifestFormatChange()">
                <mat-option [value]="null">None</mat-option>
                <mat-option *ngFor="let format of manifestFormatOptions" [value]="format">
                  {{ format.formatCode ?? format.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline"
              class="mat-md custom-select mat-select-variants remove-subscript-wrapper manifest-email-half-field"
              [class.disabled-field]="!selectedManifestFormat">
              <mat-label>Select file format</mat-label>
              <mat-icon matPrefix class="dropdown-icon">
                {{ actionIcons.keyboardDownArrow }}
              </mat-icon>
              <mat-select [(ngModel)]="selectedManifestFileFormat" [disabled]="!selectedManifestFormat">
                <mat-option *ngFor="let fileFormat of manifestFileFormatOptions" [value]="fileFormat.id">
                  {{ fileFormat.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <mat-form-field appearance="outline" class="full-height-textarea remove-subscript-wrapper">
            <mat-label>Subject</mat-label>
            <textarea matInput rows="2" [(ngModel)]="manifestEmailSubject"></textarea>
          </mat-form-field>

          <div class="manifest-attachment-section">
            <mat-form-field appearance="outline"
              class="mat-md w-full remove-subscript-wrapper manifest-attachment-input">
              <mat-label>Attachment(s)</mat-label>
              <input matInput readonly placeholder="Select File (.csv, .xls, .pdf)"
                (click)="triggerManifestAttachmentInput($event)" />
              <input type="file" #manifestAttachmentInput hidden multiple
                (change)="onManifestAttachmentSelected($event)" [accept]="manifestAcceptedFileTypes" />
            </mat-form-field>

            <div class="manifest-attachment-table-wrapper" *ngIf="manifestAttachmentList.length > 0">
              <app-data-table
                class="ibc-summary-table"
                [config]="manifestAttachmentGridConfig"
                [dataSource]="manifestAttachmentList"
                [dataSearched]="manifestAttachmentList.length > 0"
                (actionButtonClick)="onManifestAttachmentDelete($event.row)">
              </app-data-table>
              <div class="manifest-attachment-hint-text ibc-body-text-regular">
                Above are the added attachments, max of
                {{ maxManifestAttachments }} attachments are allowed.
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="
          !messagePopupData.code?.isMultiple &&
          messagePopupData.code?.isOptionalTextbox
        ">
        <mat-form-field appearance="outline" class="mat-md w-full hawb-description-textarea">
          <mat-label>Notes*</mat-label>
          <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="2" cdkAutosizeMaxRows="2" data-shortcut-number="8"
            maxlength="500" [(ngModel)]="confirmValue" placeholder="Reason for blocking"
            (input)="commentBoxChange($event)">
          </textarea>
        </mat-form-field>
      </ng-container>

      <ng-container *ngIf="
          messagePopupData.code?.isForDownload ||
          messagePopupData.code?.isForArInvoiceDownload
        ">
        <div class="download-container">
          <app-information-note *ngIf="rangeOptions && rangeOptions.length > 0" [message]="
              popupMessages.minimumNumberRangeDownload
            "></app-information-note>
          <div>
            <div
              class="confirmation-message"
              [ngClass]="
                messagePopupData.code?.downloadInstructionNormalWeight
                  ? 'ibc-body-text-regular'
                  : 'ibc-body-text-large-bold'
              ">
              {{
                messagePopupData.code?.downloadInstructionMessage ||
                  popupMessages.downloadFileText
              }}
            </div>
            <mat-radio-group
              *ngIf="messagePopupData.code?.downloadFormatOptions?.length"
              [(ngModel)]="fileType"
              class="download-file">
              <mat-radio-button
                *ngFor="let opt of messagePopupData.code.downloadFormatOptions"
                [value]="opt.value">
                <span class="ibc-body-text-medium"> {{ opt.label }} </span>
              </mat-radio-button>
            </mat-radio-group>
            <mat-radio-group
              *ngIf="!messagePopupData.code?.downloadFormatOptions?.length"
              [(ngModel)]="fileType"
              class="download-file">
              <mat-radio-button *ngIf="messagePopupData.code?.isForArInvoiceDownload" value="pdf">
                <span class="ibc-body-text-medium"> PDF </span>
              </mat-radio-button>
              <mat-radio-button value="csv">
                <span class="ibc-body-text-medium"> CSV </span>
              </mat-radio-button>
              <mat-radio-button value="excel">
                <span class="ibc-body-text-medium"> Excel </span>
              </mat-radio-button>
            </mat-radio-group>
          </div>
          <!-- Range Selection Section -->
          <ng-container *ngIf="rangeOptions && rangeOptions.length > 0">
            <div class="range-selection-container">
              <div class="range-header">
                <mat-checkbox [(ngModel)]="selectAllRanges" (change)="toggleSelectAllRanges()"
                  class="ibc-body-text-medium-bold">
                  Select Range(s)
                </mat-checkbox>
              </div>
              <div class="range-options" style="
                  margin-left: 24px;
                  margin-top: 8px;
                  display: flex;
                  flex-wrap: wrap;
                  gap: 16px;
                ">
                <mat-checkbox *ngFor="let range of rangeOptions; let i = index" [checked]="isRangeSelected(i)"
                  (change)="toggleRangeSelection(i)" class="ibc-body-text-medium">
                  Range {{ i + 1 }}
                </mat-checkbox>
              </div>
            </div>
          </ng-container>
        </div>
      </ng-container>

      <ng-container *ngIf="messagePopupData.code?.renderTable">
        <div class="shipment-gateway-table">
          <app-data-table
            class="ibc-summary-table add-border"
            [config]="gatewayRenderTableGridConfig!"
            [dataSource]="shipmentGatewayPieceTableData"
            [dataSearched]="shipmentGatewayPieceTableData.length > 0"
            (rowActionClick)="onPopupGatewayRowAction($event)"
            (selectionChange)="onMultiPieceShortageSelectionChange()">
          </app-data-table>
        </div>
        <div
          *ngIf="messagePopupData.code?.isForMultiPieceShortageGrid"
          class="multi-piece-shortage-extras">
          <mat-form-field
            appearance="outline"
            class="w-full full-height-textarea input-wrapper-none multi-piece-shortage-comments">
            <mat-label>Comments</mat-label>
            <textarea
              matInput
              rows="3"
              maxlength="250"
              [(ngModel)]="multiPieceGatewayComments"
              (blur)="commentBoxChange($event)"></textarea>
          </mat-form-field>
          <div class="ar-warning-note">
            <app-information-note
              mode="info"
              [isFrom]="'multiPieceShortageGateway'"
              [message]="getMultiPieceShortageHint()">
            </app-information-note>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="messagePopupData.code?.isForArChargesSelection">
        <div class="shipment-gateway-table">
          <app-data-table
            class="ibc-summary-table add-border"
            [config]="arChargesGridConfig!"
            [dataSource]="apChargeCodeDetailsTableData"
            [dataSearched]="apChargeCodeDetailsTableData.length > 0"
            (selectionChange)="onArChargesSelectionChange()">
          </app-data-table>
        </div>
        <div class="ar-warning-note" *ngIf="hasNotAutoRatedSelection">
          <app-information-note mode="warning" [isFrom]="'apInvoiceFetchFromSFTP'"
            [message]="popupMessages.arMultiShipmentNotAutoRatedWarning">
          </app-information-note>
        </div>
      </ng-container>

      <ng-container *ngIf="messagePopupData.code?.renderMasterShipmentTable">
        <div class="shipment-gateway-master-shipments-table">
          <app-data-table
            class="ibc-summary-table add-border"
            [config]="masterShipmentGridConfig!"
            [dataSource]="masterShipmentTableData"
            [dataSearched]="masterShipmentTableData.length > 0"
            (rowActionClick)="onPopupGatewayRowAction($event)">
          </app-data-table>
        </div>
      </ng-container>

      <ng-container *ngIf="messagePopupData.code?.renderBagShipmentTable">
        <div class="shipment-gateway-table">
          <app-data-table
            class="ibc-summary-table add-border"
            [config]="bagShipmentGridConfig!"
            [dataSource]="shipmentBagPieceTableData"
            [dataSearched]="shipmentBagPieceTableData.length > 0"
            (rowActionClick)="onPopupGatewayRowAction($event)">
          </app-data-table>
        </div>
      </ng-container>

      <ng-container *ngIf="messagePopupData.code?.renderBagScanShipmentTable">
        <div class="shipment-gateway-table">
          <app-data-table
            class="ibc-summary-table add-border"
            [config]="scanBagShipmentGridConfig!"
            [dataSource]="scanShipmentBagTableData"
            [dataSearched]="scanShipmentBagTableData.length > 0"
            (rowActionClick)="onPopupGatewayRowAction($event)">
          </app-data-table>
        </div>
      </ng-container>

      <ng-container *ngIf="messagePopupData.code?.isForMultipleBagSelection">
        <div class="multi-bag-selection-table">
          <app-data-table
            class="ibc-summary-table add-border"
            [config]="multiBagSelectionGridConfig!"
            [dataSource]="multiBagSelectionTableData"
            [dataSearched]="multiBagSelectionTableData.length > 0"
            (rowActionClick)="onPopupGatewayRowAction($event)">
          </app-data-table>
        </div>
      </ng-container>

      <ng-container *ngIf="messagePopupData.code?.renderRangesDetailTable">
        <div class="shipment-gateway-table">
          <app-data-table
            class="ibc-summary-table add-border"
            [config]="numberRangeGridConfig!"
            [dataSource]="numberRangeDetailsTableData"
            [dataSearched]="numberRangeDetailsTableData.length > 0">
          </app-data-table>
        </div>
      </ng-container>

      <ng-container *ngIf="messagePopupData.code?.apChargeCodeDetailTable">
        <div class="shipment-gateway-table">
          <app-data-table
            class="ibc-summary-table add-border"
            [config]="apChargeDetailGridConfig!"
            [dataSource]="apChargeCodeDetailsTableData"
            [dataSearched]="apChargeCodeDetailsTableData.length > 0">
          </app-data-table>
        </div>
      </ng-container>

      <ng-container *ngIf="messagePopupData.code?.isForWarning">
        <div class="isWarning-Popup">
          <app-svg-icon [iconName]="'warning'" class="cursor" [isStaticSvg]="true" [isFrom]="'Popup'"
            (staticIconClicked)="closePopup()"></app-svg-icon>
          <div class="warning-message ibc-body-text-medium {{
              messagePopupData.code?.isForHandlingExisitingAccount ||
              messagePopupData.code?.isCBPwarning
                ? 'warning-message-whitespace'
                : 'warning-message'
            }}">
            {{ messagePopupData.code?.message }}
          </div>
          <div class="form-container" *ngIf="
              messagePopupData.code?.isForWarning &&
              messagePopupData.code?.isForFirstLinkedAccount
            ">
            <mat-radio-group [(ngModel)]="selectedOption" aria-label="Select an option" class="radio-column-layout">
              <mat-radio-button *ngFor="let option of messagePopupData.code?.radioOptions" [value]="option">
                {{ option }}
              </mat-radio-button>
            </mat-radio-group>
          </div>
          <span class="form-container" *ngIf="messagePopupData.code?.isForFirstLinkedAccountCheckBox">
            <mat-checkbox [(ngModel)]="isCheckboxChecked" [checked]="true">
              <span class="ibc-body-text-medium">{{ messagePopupData.code?.checkboxData }}
              </span>
            </mat-checkbox>
          </span>
        </div>
      </ng-container>

      <ng-container *ngIf="messagePopupData.code?.isForErrorLog">
        <div class="error-log-container">
          <div *ngFor="let error of fullmanFileErrorLogMessages | keyvalue">
            <div class="error-key-message" *ngIf="error.key">{{ error.key }}</div>
            <div>
              <ol>
                <li *ngFor="let message of error.value" class="ibc-body-text-medium">
                  {{ message }}
                </li>
              </ol>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="messagePopupData.code?.isForCbpStatusDescriptionLog">
        <div
          class="cbp-status-log-container"
          [ngClass]="
            messagePopupData.code?.statusBadgeClass ||
            'fullman-file-success-status'
          ">
          <div *ngFor="let item of fullmanFileErrorLogMessages | keyvalue">
            <div class="error-key-message" *ngIf="item.key">{{ item.key }}</div>
            <div>
              <ol>
                <li *ngFor="let message of item.value" class="ibc-body-text-medium">
                  {{ message }}
                </li>
              </ol>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="messagePopupData.code?.isForAutoRatingErrorLog">
        <div *ngIf="autoRatingFailureDetailHeader"
          class="ibc-body-text-medium confirmation-message message-text">
          {{ autoRatingFailureDetailHeader }}
        </div>
        <div *ngIf="!autoRatingFailureDetailHeader && autoRatingMessage"
          class="ibc-body-text-medium confirmation-message message-text">
          {{ autoRatingMessage }}
        </div>
        <div *ngIf="autoRatingPreListCaption"
          class="ibc-body-text-medium confirmation-message message-text">
          {{ autoRatingPreListCaption }}
        </div>
        <div class="error-log-container">
          <ol>
            <li *ngFor="let message of autoRateFailedErrorMessage" class="ibc-body-text-medium">
              {{ message }}
            </li>
          </ol>
        </div>
      </ng-container>

      <ng-container *ngIf="messagePopupData.code?.isForAPErrorLog">
        <span class="ibc-body-text-medium">{{ errorLogsHeaderText }}</span>
        <div class="error-log-container" style="margin-top: 8px">
          <ol>
            <li *ngFor="let message of apFileErrorLogMessages" class="ibc-body-text-medium">
              {{ message }}
            </li>
          </ol>
        </div>
      </ng-container>

      <ng-container *ngIf="messagePopupData.code?.isForEventDescription">
        <div class="event-description-container">
          <ul>
            <li class="event-listing-container" *ngFor="let eventMessage of eventDescriptionData">
              <span class="ibc-body-text-medium">{{
                eventMessage.message
                }}</span>
              <div class="details-container users-details-container" *ngIf="isArray(eventMessage.details)">
                <mat-table [dataSource]="eventMessage.details" class="ibc-border-table users-table"
                  *ngIf="eventMessage.message === 'Users'">
                  <ng-container matColumnDef="fullName">
                    <th mat-header-cell *matHeaderCellDef class="users-col">
                      Full Name
                    </th>
                    <td mat-cell *matCellDef="let row" class="users-col">
                      {{ row.fullName }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="email">
                    <th mat-header-cell *matHeaderCellDef class="users-col">
                      Email
                    </th>
                    <td mat-cell *matCellDef="let row" class="users-col">
                      {{ row.email }}
                    </td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="userDisplayedColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: userDisplayedColumns"></tr>
                </mat-table>
              </div>
              <div class="details-container" *ngIf="
                  !isArray(eventMessage.details) &&
                  !isEmpty(eventMessage.details)
                ">
                <div *ngFor="let eventData of eventMessage.details | keyvalue" class="event-obj-display-container">
                  <span class="ibc-body-text-medium-semi-bold">{{ eventData.key }}
                  </span>
                  <span class="ibc-body-text-medium">{{
                    eventData.value
                    }}</span>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </ng-container>

      <ng-container *ngIf="messagePopupData.code?.isSendCBPClearance">
        <div>
          <p>Clearance Type</p>
          <div class="cbp-clearance">
            <mat-checkbox class="clerance-channel-options" [checked]="selectedClearanceTypeCode === 'C'"
              [disabled]="isClearanceTypeLocked('C')" (change)="onClearanceTypeChange('C')">CFS</mat-checkbox>
            <mat-checkbox class="clerance-channel-options" [checked]="selectedClearanceTypeCode === 'E'"
              [disabled]="isClearanceTypeLocked('E')" (change)="onClearanceTypeChange('E')">ECCF</mat-checkbox>
          </div>

          <p>Clearance Channel</p>
          <div class="cbp-clearance">
            <mat-checkbox class="clerance-channel-options" [checked]="isChannelChecked(clearance.name)"
              [disabled]="isChannelLocked(clearance.name)"
              (change)="onClearanceChannelToggle(clearance.name, $event.checked)"
              *ngFor="let clearance of messagePopupData.code?.clearanceType">{{ clearance.name }}</mat-checkbox>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="messagePopupData.code?.isForResponseInformationLog">
        <div class="cbp-response-description-container">
          <ng-container *ngTemplateOutlet="
              renderData;
              context: {
                $implicit: messagePopupData.code?.responseInfoData,
                key: null
              }
            "></ng-container>

          <ng-template #renderData let-data let-key="key">
            <div *ngIf="isObject(data) || isArray(data); else simpleValue">
              <div *ngIf="key !== null">
                <strong>{{ key }}:</strong>
              </div>
              <div class="cbp-response-description-container-innner-block">
                <ng-container *ngIf="isArray(data); else objectBlock">
                  <div *ngFor="let item of data; let i = index">
                    <ng-container *ngTemplateOutlet="
                        renderData;
                        context: { $implicit: item, key: i }
                      "></ng-container>
                  </div>
                </ng-container>
                <ng-template #objectBlock>
                  <div *ngFor="let k of objectKeys(data)">
                    <ng-container *ngTemplateOutlet="
                        renderData;
                        context: { $implicit: data[k], key: k }
                      "></ng-container>
                  </div>
                </ng-template>
              </div>
            </div>

            <ng-template #simpleValue>
              <div *ngIf="key !== null">{{ key }}: {{ data }}</div>
            </ng-template>
          </ng-template>
        </div>
      </ng-container>

      <ng-container *ngIf="
          messagePopupData.code?.isForLinkedAccounts &&
          messagePopupData.code?.isForRenderingTable
        ">
        <div>
          <app-data-table
            class="ibc-summary-table add-border"
            [config]="linkedAccountsGridConfig!"
            [dataSource]="messagePopupData.code?.tableData"
            [dataSearched]="(messagePopupData.code?.tableData?.length ?? 0) > 0"
            (rowClick)="onPopupLinkedAccountRowClick($event)">
          </app-data-table>
        </div>
      </ng-container>

      <ng-container *ngIf="messagePopupData.code?.isForAssociateUfoShipments">
        <div class="associate-ufo-shipments-content">
          <div class="filter-ufo-shipments">
            <div class="filter-container">
              <span class="ibc-body-text-medium-semi-bold">Filter UFO Shipments</span>
              <a class="ibc-body-link-text-small" href="#" (click)="resetUfoFilter(); $event.preventDefault()">Reset
                Filter</a>
            </div>
            <div class="form-field-container">
              <fieldset class="customInputFields date-range-fieldset-container">
                <legend class="ibc-body-table-text-small">Date Range</legend>
                <div class="date-range-form-field-container">
                  <mat-form-field appearance="outline"
                    class="mat-md custom-datepicker remove-focus remove-subscript-wrapper">
                    <mat-label>Start Date</mat-label>
                    <input matInput [matDatepicker]="ufoStartDatePicker" [(ngModel)]="ufoFilterStartDate"
                      (ngModelChange)="onUfoFiltersChanged()" />
                    <mat-datepicker-toggle matPrefix [for]="ufoStartDatePicker">
                      <mat-icon matDatepickerToggleIcon>
                        <app-svg-icon [iconName]="actionIcons.datePicker" [isStaticSvg]="true"></app-svg-icon>
                      </mat-icon>
                    </mat-datepicker-toggle>
                    <mat-datepicker #ufoStartDatePicker></mat-datepicker>
                  </mat-form-field>
                  <span class="date-separator">-</span>
                  <mat-form-field appearance="outline"
                    class="mat-md custom-datepicker remove-focus remove-subscript-wrapper">
                    <mat-label>End Date</mat-label>
                    <input matInput [matDatepicker]="ufoEndDatePicker" [(ngModel)]="ufoFilterEndDate"
                      (ngModelChange)="onUfoFiltersChanged()" />
                    <mat-datepicker-toggle matPrefix [for]="ufoEndDatePicker">
                      <mat-icon matDatepickerToggleIcon>
                        <app-svg-icon [iconName]="actionIcons.datePicker" [isStaticSvg]="true"></app-svg-icon>
                      </mat-icon>
                    </mat-datepicker-toggle>
                    <mat-datepicker #ufoEndDatePicker></mat-datepicker>
                  </mat-form-field>
                </div>
              </fieldset>
              <mat-form-field appearance="outline" class="mat-md filter-field flex-grow remove-subscript-wrapper">
                <mat-label>Shipper Name / Consignee Name</mat-label>
                <input matInput [(ngModel)]="ufoFilterShipperConsignee" (ngModelChange)="onUfoFiltersChanged()"
                  placeholder="" />
              </mat-form-field>
            </div>
          </div>
          <div class="ufo-shipment-table">
            <app-data-table
              class="ibc-summary-table add-border"
              [config]="ufoShipmentsGridConfig!"
              [dataSource]="ufoShipmentsTableData"
              [dataSearched]="isUfoShipmentsDataSearched"
              [externalTotalCount]="ufoShipmentsTotalCount"
              (selectionChange)="onUfoShipmentsSelectionChange()"
              (pageChange)="onUfoShipmentsPageChange($event)">
            </app-data-table>
          </div>
          <div class="ufo-link-icon-placeholder">
            <app-svg-icon [iconName]="'link'" [isStaticSvg]="true"></app-svg-icon>
          </div>
          <mat-form-field appearance="outline" class="mat-md w-full remove-subscript-wrapper">
            <mat-icon matPrefix class="dropdown-icon">
              {{ actionIcons.keyboardDownArrow }}
            </mat-icon>
            <mat-label>Account Number - Account Name</mat-label>
            <input matInput [formControl]="ufoAccountCtrl" [matAutocomplete]="ufoAccountAutoComplete"
              placeholder="Select account" (blur)="onUfoAccountInputBlur()" />
            <mat-autocomplete #ufoAccountAutoComplete="matAutocomplete"
              (optionSelected)="onUfoAccountSelected($event.option.value)">
              <mat-option *ngFor="let account of filteredUfoAccountOptions | async" [value]="account">
                {{ account.label }}
              </mat-option>
            </mat-autocomplete>
            <app-field-clear-suffix
              matSuffix
              [control]="ufoAccountCtrl"
              [autocomplete]="true" />
          </mat-form-field>
        </div>
      </ng-container>

      <ng-container *ngIf="messagePopupData.code?.isForSendInvoiceViaEmail">
        <div class="select-email-form-container">
          <mat-checkbox [(ngModel)]="isCheckboxChecked" (ngModelChange)="onSendToMeCheckboxChange($event)">Send it to
            me</mat-checkbox>
          <mat-form-field class="chip-autocomplete-field remove-subscript-wrapper" appearance="outline">
            <mat-label>Select Emails</mat-label>
            <mat-chip-grid #chipGrid aria-label="Email selection">
              <mat-chip-row *ngFor="let email of selectedEmails" (removed)="remove(email)"
                [aria-description]="'press enter to edit ' + email">
                {{ email }}
                <button matChipRemove [attr.aria-label]="'remove ' + email">
                  <mat-icon>cancel</mat-icon>
                </button>
              </mat-chip-row>
            </mat-chip-grid>
            <input placeholder="Type or select Emails..." #emailInput [formControl]="emailCtrl"
              [matChipInputFor]="chipGrid" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              (matChipInputTokenEnd)="add($event)" [matAutocomplete]="auto" />
            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
              <mat-option *ngFor="let email of filteredEmails | async" [value]="email">
                {{ email }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>

          <mat-form-field appearance="outline"
            class="mat-md custom-select mat-select-variants remove-subscript-wrapper">
            <mat-label>Select Format</mat-label>
            <mat-icon matPrefix class="dropdown-icon">
              {{ actionIcons.keyboardDownArrow }}
            </mat-icon>
            <mat-select [(ngModel)]="selectedFileFormats" multiple>
              <mat-option *ngFor="let format of invoiceFileFormatOptions" [value]="format.id">
                {{ format.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-height-textarea">
            <mat-label>Subject</mat-label>
            <textarea matInput rows="2" [(ngModel)]="emailSubject"></textarea>
          </mat-form-field>
        </div>
      </ng-container>

      <ng-container *ngIf="messagePopupData.code?.isForUploadInvoiceForAp">
        <div class="upload-ap-invoice-container">
          <div class="upload-invoice-container">
            <app-svg-icon [iconName]="'uploadInvoice'" class="invoice-upload" [isStaticSvg]="true"></app-svg-icon>
            <a href="#" class="hyperlink" (click)="triggerFileInput($event)">Upload a file</a>
            <input type="file" #fileInput hidden (change)="onFileSelected($event)" [accept]="acceptedFileTypes" />
            <span>to upload the xlsx / csv file</span>
          </div>
          <div class="upload-invoice-instructions-container">
            <ul class="ibc-body-text-regular">
              <li>The file has to be in the format of .xlsx, .csv</li>
              <li>
                The uploaded file must adhere to the template outlined in the AP
                Invoice grid. If the uploaded file structure does not match this
                template, the upload will be unsuccessful.
              </li>
            </ul>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="messagePopupData.code?.forCopyRateScale">
        <div class="copy-rate-scale-container" [formGroup]="copyRateScaleForm">
          <span class="ibc-body-text-medium">{{ messagePopupData.code?.copyMessage }}
          </span>
          <span class="ibc-body-text-medium">Please provide a name for the new rate scale and enter the desired
            markup percentage
          </span>
          <div class="form-container">
            <mat-form-field appearance="outline" class="mat-md remove-subscript-wrapper">
              <mat-label>Rate Scale</mat-label>
              <input matInput formControlName="rateScaleName" />
              <app-svg-icon *ngIf="checkFormFieldForError('rateScaleName')" matSuffix [iconName]="'infoCircle'"
                [isStaticSvg]="true" class="cursor info-icon-error"
                (click)="fetchFormFieldWidth($event, 'rateScaleName')" (keydown)="$event.stopPropagation()">
              </app-svg-icon>
              <app-custom-error-tooltip *ngIf="
                  checkFormFieldForError('rateScaleName') &&
                  setRateScaleCopyInfoErrorTooltip['rateScaleName']
                " [tooltipWidth]="setRateScaleCopyInfoWidth['rateScaleName']"
                [tooltipText]="fetchFormFieldErrorMessage('rateScaleName')" (tooltipCloseClicked)="
                  commonService.closeErrorTooltip(
                    'rateScaleName',
                    setRateScaleCopyInfoErrorTooltip
                  )
                ">
              </app-custom-error-tooltip>
            </mat-form-field>
            <mat-form-field appearance="outline" class="mat-md remove-subscript-wrapper">
              <mat-label>Markup (%)</mat-label>
              <input matInput formControlName="markup" [appDigitWithTwoDecimalNumber]="2" />
              <app-svg-icon *ngIf="checkFormFieldForError('markup')" matSuffix [iconName]="'infoCircle'"
                [isStaticSvg]="true" class="cursor info-icon-error" (click)="fetchFormFieldWidth($event, 'markup')"
                (keydown)="$event.stopPropagation()">
              </app-svg-icon>
              <app-custom-error-tooltip *ngIf="
                  checkFormFieldForError('markup') &&
                  setRateScaleCopyInfoErrorTooltip['markup']
                " [tooltipWidth]="setRateScaleCopyInfoWidth['markup']"
                [tooltipText]="fetchFormFieldErrorMessage('markup')" (tooltipCloseClicked)="
                  commonService.closeErrorTooltip(
                    'markup',
                    setRateScaleCopyInfoErrorTooltip
                  )
                ">
              </app-custom-error-tooltip>
            </mat-form-field>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="messagePopupData.code?.isForAPInvoiceFetchFromSFTP">
        <div class="ap-invoice-fetch-from-sftp-container">
          <app-information-note isFrom="apInvoiceFetchFromSFTP" mode="info"
            [message]="apInvoiceFetchFromSFTPMessage"></app-information-note>
          <div class="ap-sftp-files-table-container">
            <app-data-table
              class="ibc-summary-table"
              [config]="apSftpFilesGridConfig!"
              [dataSource]="apSftpFilesTableData"
              [dataSearched]="isApSftpFilesDataSearched"
              (selectionChange)="onApSftpFilesSelectionChange()">
            </app-data-table>
          </div>
          <app-information-note *ngIf="!areSelectedAgentsUniform" isFrom="apInvoiceFetchFromSFTP" mode="warning"
            [message]="
              apInvoiceFetchFromSFTPWarningMessage
            "></app-information-note>
        </div>
      </ng-container>
    </div>

    <div class="popup-footer warning" *ngIf="
        messagePopupData.code?.isFooterRequired &&
        messagePopupData.code?.isForWarning &&
        !messagePopupData.code?.footerButtonList &&
        !messagePopupData.code?.hasMiscellaneousAccount &&
        !messagePopupData.code?.hasUFOAccount &&
        !messagePopupData.code?.isApChargeDuplicateEntry
      ">
      <button class="ibc-medium-button ibc-primary-default-button cursor" (click)="confirm()">
        <span class="ibc-body-text-regular">
          {{
          messagePopupData.code?.isAccountDependency
          ? popupButtons.Close
          : popupButtons.Ok
          }}
        </span>
      </button>
    </div>

    <div class="popup-footer warning" *ngIf="
        (this.messagePopupData.code?.hasMiscellaneousAccount ||
          this.messagePopupData.code?.hasUFOAccount) &&
        !messagePopupData.code?.isApChargeDuplicateEntry
      ">
      <div class="has-misc-account-container">
        <button class="ibc-medium-button ibc-secondary-default-button cursor" (click)="closePopup()">
          <span class="ibc-body-text-regular">
            {{ popupButtons.Cancel }}
          </span>
        </button>
        <button class="ibc-medium-button ibc-primary-default-button cursor" (click)="confirm()">
          <span class="ibc-body-text-regular">
            {{ popupButtons.Delete }}
          </span>
        </button>
      </div>
    </div>

    <div *ngIf="messagePopupData.code?.isApChargeDuplicateEntry" class="ap-dup-container">
      <div class="dup-header-row">
        <div></div>
        <div class="dup-actions" *ngIf="isDuplicateMulti">
          <ng-container *ngIf="!multiDuplicateAction; else multiDupStatus">
            <button class="ibc-small-button ibc-caution-default-button cursor" (click)="markAllDuplicates('remove')">
              Remove All
            </button>
            <button class="ibc-small-button ibc-primary-default-button cursor" (click)="markAllDuplicates('allow')">
              Allow All
            </button>
          </ng-container>
          <ng-template #multiDupStatus>
            <span [ngClass]="
                multiDuplicateAction === popupConditions.allow
                  ? 'dup-global-status-text dup-status-allowed'
                  : 'dup-global-status-text dup-status-removed'
              ">
              {{
              multiDuplicateAction === popupConditions.allow
              ? 'All Duplicate Charges Allowed'
              : 'All Duplicate Charges Removed'
              }}
            </span>
            <button class="ibc-small-button ibc-secondary-default-button cursor" (click)="undoAllDuplicates()">
              Undo changes
            </button>
          </ng-template>
        </div>

        <div class="dup-actions" *ngIf="!isDuplicateMulti">
          <ng-container *ngIf="!singleDuplicateAction; else singleDupStatus">
            <button class="ibc-small-button ibc-secondary-default-button cursor"
              (click)="selectSingleDuplicate('remove')">
              Remove Duplicate Charge
            </button>
            <button class="ibc-small-button ibc-primary-default-button cursor" (click)="selectSingleDuplicate('allow')">
              Allow Duplicate
            </button>
          </ng-container>
          <ng-template #singleDupStatus>
            <button class="ibc-small-button" [ngClass]="
                singleDuplicateAction === popupConditions.allow
                  ? 'dup-status-badge dup-status-allowed'
                  : 'dup-status-badge dup-status-removed'
              " disabled>
              {{
              singleDuplicateAction === popupConditions.allow
              ? 'Duplicate Charges Allowed'
              : 'Duplicate Charges Removed'
              }}
            </button>
          </ng-template>
        </div>
      </div>

      <ng-container *ngIf="
          !isDuplicateMulti && duplicateList.length > 0;
          else multipleDuplicatesTpl
        ">
        <div class="duplicate-box">
          <div class="row">
            <div class="col">
              Shipment Identifier
              <div>{{ duplicateList[0].shipmentIdentifier }}</div>
            </div>
            <div class="col">
              Shipment Identifier Value
              <div>{{ duplicateList[0].shipmentIdentifierValue }}</div>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-template #multipleDuplicatesTpl>
        <div class="dup-wrapper">
          <div class="dup-card" *ngFor="let dup of duplicateList; let i = index">
            <div class="dup-card-header">
              <div>Duplicate charge #{{ i + 1 }}</div>

              <div class="dup-actions">
                <ng-container [ngSwitch]="duplicateSelection.get(dup.id)">
                  <ng-container *ngSwitchCase="'allow'">
                    <button class="dup-status-badge dup-status-allowed" disabled>
                      Duplicate Charges Allowed
                    </button>
                  </ng-container>
                  <ng-container *ngSwitchCase="'remove'">
                    <button class="dup-status-badge dup-status-removed" disabled>
                      Duplicate Charges Removed
                    </button>
                  </ng-container>
                  <ng-container *ngSwitchDefault>
                    <button class="ibc-small-button ibc-secondary-default-button cursor"
                      (click)="selectDuplicateFor(dup.id, 'remove')">
                      Remove Duplicate Charge
                    </button>
                    <button class="ibc-small-button ibc-primary-default-button cursor"
                      (click)="selectDuplicateFor(dup.id, 'allow')">
                      Allow Duplicate
                    </button>
                  </ng-container>
                </ng-container>
              </div>
            </div>

            <div class="duplicate-box">
              <div class="row">
                <div class="col">
                  Shipment Identifier
                  <div>{{ dup?.shipmentIdentifier }}</div>
                </div>
                <div class="col">
                  Shipment Identifier Value
                  <div>{{ dup?.shipmentIdentifierValue }}</div>
                </div>
              </div>
            </div>
            <div *ngIf="i < duplicateList.length - 1" class="dup-divider"></div>
          </div>
        </div>
      </ng-template>
    </div>

    <div class="popup-footer" *ngIf="messagePopupData.code?.isApChargeDuplicateEntry">
      <button class="ibc-medium-button ibc-secondary-default-button cursor" (click)="onDuplicateCancel()">
        <span class="ibc-body-text-regular">{{ popupButtons.Cancel }}</span>
      </button>
      <button class="ibc-medium-button ibc-primary-default-button"
        [ngClass]="!isDuplicateConfirmDisabled() ? 'cursor' : ''" [disabled]="isDuplicateConfirmDisabled()"
        (click)="confirmDuplicateSelection()">
        <span class="ibc-body-text-regular">{{ popupButtons.Confirm }}</span>
      </button>
    </div>

    <div class="popup-footer popup-footer--ar-additional-charges-modal"
      *ngIf="messagePopupData.code?.isArAdditionalChargesModal">
      <button type="button" class="ibc-medium-button ibc-secondary-default-button cursor"
        (click)="emitArAdditionalChargesChoice(arAdditionalChargesChoice.linkToExisting)">
        <span class="ibc-body-text-regular">
          {{ arAdditionalChargesModalCopy.linkToExistingArInvoiceLabel }}
        </span>
      </button>
      <button type="button" class="ibc-medium-button ibc-primary-default-button cursor"
        (click)="emitArAdditionalChargesChoice(arAdditionalChargesChoice.createNew)">
        <span class="ibc-body-text-regular">
          {{ arAdditionalChargesModalCopy.createNewArInvoiceLabel }}
        </span>
      </button>
    </div>

    <div class="popup-footer warning" *ngIf="
        messagePopupData.code?.isFooterRequired &&
        messagePopupData.code?.isForWarning &&
        messagePopupData.code?.footerButtonList
      ">
      <button *ngFor="let button of this.messagePopupData.code?.footerButtonList" class="{{ button.btnClass }}"
        [disabled]="
          button.name === 'Proceed' &&
          !selectedOption &&
          !messagePopupData.code?.isForProceedChanges
        " (click)="handleFooterButtonActions(button.name)">
        <span class="ibc-body-text-regular">
          {{ button.name }}
        </span>
      </button>
    </div>
    <div class="popup-footer" *ngIf="
        messagePopupData.code?.isFooterRequired &&
        messagePopupData.code?.isBulkEditEligibilityTerminal
      ">
      <button class="cursor ibc-medium-button ibc-primary-default-button" (click)="closePopup()">
        <span class="ibc-body-text-regular">{{ popupButtons.Ok }}</span>
      </button>
    </div>
    <div class="popup-footer" *ngIf="
        messagePopupData.code?.isFooterRequired &&
        !messagePopupData.code?.isForWarning &&
        !messagePopupData.code?.isBulkEditEligibilityTerminal
      ">
      <button *ngIf="
          !messagePopupData.code?.renderRangesDetailTable &&
          !messagePopupData.code?.apChargeCodeDetailTable &&
          !messagePopupData.code?.isApChargeDuplicateEntry
        " class="cursor ibc-medium-button {{
          messagePopupData.code?.isBulk
            ? 'ibc-caution-secondary-button'
            : !messagePopupData.code?.isMultiple &&
                messagePopupData.code?.isOptionalTextbox
              ? 'ibc-caution-secondary-button'
              : 'ibc-secondary-default-button'
        }}" (click)="closePopup()">
        <span class="ibc-body-text-regular">{{ getCancelButtonName() }}</span>
      </button>
      <button class="cursor ibc-secondary-accent-button-md" *ngIf="messagePopupData.code?.isForGatewayLocationMismatch"
        (click)="editShipment()">
        <span class="ibc-body-text-regular">{{
          popupButtons.editShipment
          }}</span>
      </button>
      <ng-container *ngIf="
          messagePopupData.code?.isForDownload ||
          messagePopupData.code?.isForArInvoiceDownload
        ">
        <button class="ibc-medium-button ibc-primary-default-button" [ngClass]="!isDownloadEnabled() ? '' : 'cursor'"
          (click)="confirm()" [disabled]="!isDownloadEnabled()">
          <span class="ibc-body-text-regular">
            {{
              messagePopupData.code?.downloadConfirmButtonLabel ||
                popupButtons.Download
            }}
          </span>
        </button>
      </ng-container>
      <ng-container *ngIf="
          !messagePopupData.code?.isForDownload &&
          !messagePopupData.code?.isForArInvoiceDownload &&
          !messagePopupData.code?.renderRangesDetailTable &&
          !messagePopupData.code?.apChargeCodeDetailTable &&
          !messagePopupData.code?.isApChargeDuplicateEntry
        ">
        <button class="ibc-medium-button {{
            messagePopupData.code?.isBulk
              ? 'ibc-caution-default-button'
              : !messagePopupData.code?.isMultiple &&
                  messagePopupData.code?.isOptionalTextbox
                ? 'ibc-caution-default-button ibc-body-text-regular'
                : 'ibc-primary-default-button'
          }}" [ngClass]="getClassValueForEnableDisable() ? '' : 'cursor'" [ngClass]="
            messagePopupData.code?.isForUploadInvoiceForAp ? 'hide-btn' : ''
          " (click)="confirm()" [disabled]="isButtonDisabled()">
          <span class="ibc-body-text-regular">
            {{ getPopupButtonLabel()
            }}{{ confirmCountdown > 0 ? ' (' + confirmCountdown + ')' : '' }}
          </span>
        </button>
      </ng-container>

      <ng-container *ngIf="
          !messagePopupData.code?.isForDownload &&
          !messagePopupData.code?.isForArInvoiceDownload &&
          (messagePopupData.code?.renderRangesDetailTable ||
            messagePopupData.code?.apChargeCodeDetailTable)
        ">
        <button class="ibc-medium-button ibc-primary-default-button cursor" (click)="confirm()">
          <span class="ibc-body-text-regular">{{
            messagePopupData.code?.isForFinalDestRoutingConfirm
              ? popupButtons.Ok
              : ' Close '
          }}</span>
        </button>
      </ng-container>
    </div>
  </div>
</div>